import { DynamicButtonStatus } from '../../design-system';
import { Cart, NotificationType, State, CartStep } from './types';

export const emptyCart: Cart = {
  cartId: '',
  items: [],
  couponCode: '',
  totalCouponAmount: 0,
  couponAccepted: false,
  shippingType: undefined,
  storeId: '',
  pickupStation: undefined,
  shippingAmount: 0,
  freeShipping: false,
  rejectCouponMessage: '',
  totalDiscount: 0,
  notifications: [
    {
      type: NotificationType.Offer,
      title: '',
      message: '',
    },
  ],
  originalBaseTotal: 0,
  total: 0,
  isGiftEnabled: false,
  isValidated: false,
  isDigital: false,
};

export const paypalECSInitialState = {
  data: {
    authorizedEvent: {
      payer: {
        email_address: '',
        name: { given_name: '', surname: '' },
        phone: { phone_number: { national_number: '' } },
      },
    },
    billingAddress: {
      houseNumberOrName: '',
      street: '',
      postalCode: '',
      city: '',
      country: '',
      stateOrProvince: '',
      firstName: '',
      lastName: '',
    },
    deliveryAddress: {
      houseNumberOrName: '',
      street: '',
      postalCode: '',
      city: '',
      country: '',
      stateOrProvince: '',
      firstName: '',
      lastName: '',
    },
  },
  cart: { ...emptyCart },
  details: { details: {}, paymentData: '', sessionData: '' },
  successData: { email: '', orderNumber: '' },
  cognito: { initialCognitoId: '' },
};

export const orderSuccessDataInitialState = {
  deliveryAddress: {
    id: '',
    name: '',
    company: '',
    idTva: '',
    siret: '',
    firstName: '',
    lastName: '',
    street: '',
    streetAdditional: '',
    postal: '',
    city: '',
    phone: '',
    country: '',
  },
  cart: { ...emptyCart },
};

export const cartState: State = {
  cart: { ...emptyCart },
  errMsg: '',
  isFetching: true,
  couponCodeIsLoading: false,
  step: CartStep.LISTING,
  ctaState: DynamicButtonStatus.Default,
  shippingTypes: [],
  paypalECS: paypalECSInitialState,
  orderSuccessData: orderSuccessDataInitialState,
  showFeedback: false,
};
